export default "__VITE_ASSET__AFpNt2PA__"